module.exports = __webpack_public_path__ + "static/staff_of_the_magi-5c7ac7df646e84cbf769aa544d6c11df.jpeg";